import { render, staticRenderFns } from "./TypeaheadPerson.vue?vue&type=template&id=1a577999&"
import script from "./TypeaheadPerson.vue?vue&type=script&lang=js&"
export * from "./TypeaheadPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports